<template>
    <div class="flex col packDetails">
        <!-- <div class="unit_haeder">中国消费扶贫生活馆</div> -->

        <div class="unit_center">
            <div class="unit_center_post">
                <van-search
                    style="width:100%"
                    v-model="unitParams.popTitle"
                    show-action
                    placeholder="搜索招标项目名称"
                    @search="onSearch"
                    @cancel="onCancelBox"
                />
                <div class="unit_center_select" >
                    <!-- <div class="unit_center_select_item flex row flex-center" @click="provinceName">
                        <span style="font-size:0.26rem;">{{unitParams.isSync?isSyncObjsText[unitParams.isSync]:'全部'}}</span>
                        <img src="../assets/images/down.png" class="select_item_imgs" alt="" srcset="">
                    </div> -->
                    <div class="unit_center_select_item flex row flex-center" :style="'color:'+muns==1?'#5FA7EB':'#fff'" @click="today(1)">
                        今天
                    </div>
                    <div class="unit_center_select_item flex row flex-center" :style="'color:'+muns==2?'#5FA7EB':'#fff'" @click="today(2)">
                        昨天
                    </div>
                    <div class="unit_center_select_item flex row flex-center">
                        <el-select v-model="tpSelect"  value-key="tp_id" placeholder="招标类型" @change="tpSel">
                            <el-option
                            v-for="item in tpOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="unit_center_select_item flex row flex-center">
                        <el-select v-model="templateSelect"  value-key="tem_id" placeholder="选择模板" @change="temSel">
                            <el-option
                            v-for="item in options"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="unit_center_select_item flex row flex-center" style="width:2.3rem" @click="countyName">
                        <span class="flex row flex-center" style="font-size:0.26rem;" :style="'color:'+muns==3?'#5FA7EB':'#fff'">{{unitParams.beginAt?unitParams.beginAt+'-'+unitParams.endAt:'日期区间'}}</span>
                        <img src="../assets/images/down.png" class="select_item_imgs" alt="" srcset="">
                    </div>

                    <!-- <div class="unit_center_select_itemText flex row flex-center"  @click="addName">
                        <span class="flex row flex-center" style="font-size:0.26rem;">关键字</span>
                        <img src="../assets/images/down.png" class="select_item_imgs" alt="" srcset="">
                    </div> -->
                </div>
            </div>

            <div class="unit_center_footer" >
                <div class="footer_name">招标项目列表</div>
                <van-list
                    v-model="loading"
                    :finished="finished"
                    :finished-text="finishedText"
                    @load="onLoad"
                >
                    <div class="flex col unit_center_list" v-for="(item) in listInfo" :key="item.id">
                        <div class="flex row footer_list" @click="addPopTitle(item)">
                            <div class="flex-item flex  footer_nums">{{item.popTitle}}</div>

                        </div>
                        <div  class="flex row footer_list">
                            <div style="color:blue;">[{{item.ifbTpStr}}]</div>
                            <div style="color:red;">[{{item.temName}}]</div>
                        </div>

                        <div class="footer_list_bot">
                            <div>{{item.ctDate}}</div>
                            <div @click="addName(item)">打开招标文件</div>
                            <!-- <div  >
                                <a :href="'http://114.132.50.11/upload/content/'+item.localLinkUrl" style="color:blue" target="_blank">{{'打开'+item.fileTp.substring(1)}}</a>
                            </div> -->
                        </div>
                    </div>
                </van-list>
            </div>

        </div>
        <van-popup v-model="KeywordShow">
            <!-- <div class="Keyword_box">
                <van-field v-model="KeywordValue" placeholder="请输入关键词" />
                <van-button type="info" style="width:1.8rem;" @click="addKeyword">添加</van-button>
            </div> -->
            <div class="Keyword_List">
                <a class="Keyword_List_item"  v-for="(item,index) in KeywordList" :key="index" :href="item.localLinkUrl">{{item.fileName}}</a>
                <!-- <div class="Keyword_List_item" v-for="(item,index) in KeywordList" :key="index" @click="delList(index)">{{item}}</div> -->
            </div>
        </van-popup>
        <van-calendar v-model="timeShow" :min-date="new Date('2021/01/01')"  type="range" @confirm="onConfirmTime" />
        <van-popup v-model="showPicker" round position="bottom">
            <van-picker show-toolbar
                :title="unitObjs[unitType]"
                @confirm="onConfirm"
                @cancel="onCancel"
                @change="onChange"
                :columns="columns"
                :default-index="1" />
        </van-popup>

    </div>
</template>
<script>
import { queryPage,queryPageSolrfile,queryPageDocument,query,save,createKeyword,getList,temList} from '../api/bidding'
export default {
    name: "login",
    data(){
        return{
            muns:1,
            userName:'',
            passWord:'',
            select_name:'',
            search_text:'',
            value: '',
            radio:'0',
            timeShow:false,
            KeywordShow:false,
            KeywordList:[],
            KeywordValue:'',
            showPicker: false,
            listInfo:[],
            loading: false, //上拉加载中
            finished: true, //上拉加载结束
            finishedText:'',
            loading2: true, //上拉加载中
            finished2: false, //上拉加载结束
            finishedText2:'',
            listCheck:true,
            list:[

            ],
            columName:'全部',
            columns: ['全部','已通过','未通过'],
            unitParams:{
                popTitle:'',
                beginAt:'',
                endAt:'',
                pageNo:1,
                pageSize:10,
                temId:'',
                ifbTp:'',
            },
            unitObjs:{
                1:'是否通过',
                2:'权重',
            },
            isSyncObjs:{
                '全部':'',
                '已通过':'Y',
                '未通过':'x',
            },
            isSyncObjsText:{
                '':'全部',
                'Y':'已通过',
                'x':'未通过',
            },
            options: [],
            tpOptions: [
                {
                value: '1',
                label: '普通标'
                }, {
                value: '2',
                label: '资审标'
                }, {
                value: '3',
                label: '无文件标'
                }
            ],
            unitType:1,
            provinceList:[],
            cityList:[],
            countyList:[],
            unitqueryList:[],
            pageTotel:1,
            custObj:{
                custNm:'',
                cnsgnPrvc:'',
                cnsgnUrbn:'',
                cnsgnZon:'',
                dateRange:'0',
                pageNumber:1,
                pageSize:5,
            },
            numFilter(value) {
                const realVal = parseFloat(value).toFixed(2);
                return realVal;
            },
            cityPicker:false,  //权重

        }
    },
    components: {
    },
    mounted(){
        // this.listInfo = this.list
        // this.queryPageByCust()
        this.today(1)
    },
    methods:{
        // 打开文件
        // addUrl(row){
        //     let fileTp = row.fileTp.substring(1)
        //     if(fileTp=='pdf'){
        //         this.pdfShow = true
        //         this.$router.push({
        //             path:'/pdfUrl',
        //             query:{
        //                 pdfUrl:row.localLinkUrl
        //             }
        //         })
        //     }
        // },
        // 进入详情
        addPopTitle(row){

            console.log(row,'进入详情页')
            // content
            this.$router.push({
                path:'/sweep',
                query:{
                    id:row.id,
                    contentId:row.contentId
                }
            })
            // this.$router.push('/sweep')
        },
        addName(item){
            this.KeywordShow = true
            getList({contentId:item.contentId}).then(res=>{
                if(res.data.code=='000000'){
                    this.KeywordList=res.data.data
                }
            })
        },
        createKeyword(){
            let obj = {
            keyword:'kv',
            data:this.KeywordList.join("/")
            }
            createKeyword(obj).then(res=>{
            if(res.data.code=='000000'){
                console.log(res.data.data)
                // this.menuList = res.data.data
            }
            })
        },
        //模板select改变
        temSel(selVal){
            this.temId = selVal
            this.unitParams.pageNo =1
            this.listInfo = []
            this.queryPageByCust()
            console.log(selVal,'selVal')
        },
        //招标类型select改变
        tpSel(selVal){
            this.ifbTp = selVal
            this.unitParams.pageNo =1
            this.listInfo = []
            this.queryPageByCust()
            console.log(selVal,'selVal')
        },
        //模板列表
        getTemList(){
            temList().then(res=>{
                if(res.data.code=='000000'){
                    this.options=res.data.data
                }
            })
        },
        // 添加关键词
        addKeyword(){
            this.KeywordList.push(this.KeywordValue)
            this.KeywordValue = ''
            this.queryPageByCust()
        },
        // 删除关键词
        delList(i){
            this.KeywordList.splice(i,1)
            this.queryPageByCust()
        },
        // 日期区间
        formatDate(date) {
            return `${date.getMonth()+1}-${date.getDate()}`;
        },
        onConfirmTime(date) {
            const [start, end] = date;
            this.timeShow = false;
            this.unitParams.beginAt = `${this.formatDate(start)} `;
            this.unitParams.endAt = `${this.formatDate(end)}`;
            this.listInfo = []
            this.unitParams.pageNo = 1
            this.unitParams.temId = this.temId
            this.unitParams.ifbTp =this.ifbTp
            this.queryPageByCust();
        },

        // 单位查询结果
        queryOrderInfo(){
            queryOrderInfo(this.custObj).then(res=>{
                if(res.data.code=='000000'){
                    this.unitqueryList = this.unitqueryList.concat(res.data.data.list)
                    this.custObj.pageNumber++
                    if (this.unitqueryList.length < 1) {
                        this.finishedText2 = "暂无数据";
                        this.finished2 = true; //上拉结束
                    } else if (res.data.data.list.length < 10) {
                        this.finishedText2 = "没有更多了";
                        this.finished2 = true; //上拉结束
                    } else {
                        this.finished2 = false;
                        this.loading2 = false;
                    }

                }
            })
        },
        // 选择查询结果
        addInfo(obj){
            this.listCheck = false
            this.custObj = {
                custNm:obj.custNm,
                cnsgnPrvc:this.unitParams.province,
                cnsgnUrbn:this.unitParams.city,
                cnsgnZon:this.unitParams.county,
                dateRange:this.radio,
                pageNumber:1,
                pageSize:5,
            }
            this.queryOrderInfo()
        },
        // 跳转统计页面
        statistics(){
            this.$router.push('/sweep')
        },
        onLoad() {
            // debugger
            console.log(this.finished,'finished')
            if(!this.finished){
                this.queryPageByCust();
            }

        },
        // 取消重置
        onCancelBox(){
            this.unitParams = {
                popTitle:'',
                beginAt:'',
                endAt:'',
                pageNo:1,
                pageSize:5,
                temId:'',
                ifbTp:'',
            }
            this.queryPageByCust()
        },
        // 获取数据
        queryPageByCust(){
            var date=new Date;
            var y = date.getFullYear()
            console.log(y,'年')
            // this.createKeyword()
            // this.unitParams.beginAt = this.unitParams.beginAt?y+'-'+this.unitParams.beginAt:''
            // this.unitParams.endAt = this.unitParams.endAt?y+'-'+this.unitParams.endAt:''
            // this.unitParams.sort =this.unitParams.sort=='全部'?'':this.unitParams.sort
            let objs = {
                // isSync:this.unitParams.isSync,
                popTitle:this.unitParams.popTitle,
                beginAt:this.unitParams.beginAt?y+'-'+this.unitParams.beginAt:'',
                endAt:this.unitParams.endAt?y+'-'+this.unitParams.endAt:'',
                // sort:this.unitParams.sort,
                pageNo:this.unitParams.pageNo,
                pageSize:10,
                temId:this.temId,
                ifbTp:this.ifbTp
            }
            queryPageSolrfile(objs).then(res=>{
                if(res.data.code=='000000'){
                    console.log(res.data,'招标项目')
                    this.listInfo =this.listInfo.concat(res.data.data.data)
                    this.pageTotel = res.data.data.paginator.page
                    console.log(this.listInfo,'listInfo')
                    this.unitParams.pageNo++
                    // if (this.listInfo.length < 1) {
                    //     this.finishedText = "暂无数据";
                    //     this.finished = true; //上拉结束
                    // } else if (res.data.data.data.length < 10) {
                    //     this.finishedText = "没有更多了";
                    //     this.finished = true; //上拉结束
                    // } else {
                    //     this.finished = false;
                    //     this.loading = false;
                    // }
                    var lastPage = res.data.data.paginator.lastPage
                    if(this.unitParams.pageNo<=lastPage){
                        this.finished = false;
                        this.loading = false;
                    }else{
                        this.finishedText = "没有更多了";
                        this.finished = true; //上拉结束
                        this.loading = true;
                    }
                    // console.log(this.unitParams.pageNo,'this.unitParams.pageNo')
                    // console.log(lastPage,'lastPage')
                }
            })

        },

        // 省
        provinceName(){
            this.unitType = 1
            this.showPicker = true
            this.columns=['全部','已通过','未通过']
            // this.areaList({parentId:'',grade:1})
        },
        // 市
        cityName(){
            this.unitType = 2
            this.showPicker=true
            this.columns=['全部','p1','p2','p3']
        },
        today(num){
            this.muns = num
            this.unitParams.temId = this.temId
            this.unitParams.ifbTp = this.ifbTp
            this.unitParams.pageNo = 1
            if(num==1){
                var day2 = new Date();
                day2.setTime(day2.getTime());
                var s2 =  (day2.getMonth()+1) + "-" + day2.getDate();
                this.unitParams.beginAt=s2
                this.unitParams.endAt=s2

            }else if(num==2){
                var day1 = new Date();
                day1.setTime(day1.getTime()-24*60*60*1000);
                var s1 =  (day1.getMonth()+1) + "-" + day1.getDate();
                this.unitParams.beginAt=s1
                this.unitParams.endAt=s1
            }
            this.listInfo = []
            this.queryPageByCust()
            this.getTemList()
        },
        // 区县
        countyName(){
            this.muns = 3
            this.timeShow = true
        },
        onSearch(val) {
            // this.listInfo = this.getSearchList(val)
            this.listInfo = []
            this.unitParams.pageNo = 1
            this.unitParams.temId = this.temId
            this.unitParams.ifbTp = this.ifbTp
        },
        getSearchList(val){
            if(val){
                return this.list.filter((value)=>{  //过滤数组元素
                    return value.name.includes(val); //如果包含字符返回true
                });
            }
        },
        onCancel() {
             this.listInfo = this.list
        },
       onConfirm(value, index) {
           this.showPicker = false
           if(this.unitType==1){
               this.unitParams.isSync =this.isSyncObjs[value]
           }else if(this.unitType==2){
               this.unitParams.sort = value
           }
           this.unitParams.pageNo = 1
           this.unitParams.temId = this.temId
           this.unitParams.ifbTp = this.ifbTp
           this.listInfo = []
           this.queryPageByCust()
        },
        onChange(picker, value, index) {
        // Toast(`当前值：${value}, 当前索引：${index}`);
        },

    }
}
</script>
<style scoped>
    body{
        background: #999999;
    }
    .packDetails{
        width: 100%;
        height: 100vh;

    }
    .Keyword_box{
        width: 7rem;
        display: flex;
        padding: 0.2rem;
        box-sizing: border-box;
        justify-content: space-between;
    }
    .Keyword_List{
        margin: 0.2rem;
        display: flex;
        /* flex-wrap: wrap; */
        flex-direction: column;
    }
    .Keyword_List_item{
        padding: 0.2rem;
        box-sizing: border-box;
        background: #ccc;
        border-radius: 0.1rem;
        color: #333;
        margin: 0.1rem;
    }
    .footer_uind{
       margin-top: 0.2rem;
       background: #fff;
    }
    .van-radio-group{
        display: flex;
        flex-direction: row;
    }
    .van-radio__icon{
        font-size: 16px;
    }
    .van-radio__icon .van-icon{
        width: 1em;
        height: 1em;
        line-height: 1em;
    }
    .van-radio{
        margin-right: 0.18rem;
        font-size: 0.24rem;
    }
    .unit_center_data{
        padding: 0.13rem 0.2rem;
        box-sizing: border-box;
        background: #fff;
        border-radius: 0.06rem;
    }
    .unit_center_data_haeder{
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 0.28rem;
        font-family: Source Han Sans CN;
        font-weight: 500;
        margin-bottom: 0.5rem;
    }
    .unit_center_post{
        position: fixed;
        top: 0rem;
        left: 0;
        width: 100%;
        padding: 0.15rem 0.18rem;
        box-sizing: border-box;
        background: #ccc;

    }
     .unit_haeder{
        height: 1.28rem;
        background: #E6A23C;
        padding-bottom: 0.2rem;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        font-size: 0.34rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
     }
     .unit_center{
         padding: 0.14rem 0.18rem .01rem 0.18rem;
         box-sizing: border-box;
     }
     .unit_center_search{
        height: 0.8rem;
        width: 100%;
        /* background: #FFFFFF; */
        border-radius: 0.05rem;
        display: flex;
        /* justify-content: space-between; */
        align-items: center;
        padding: 0 0.18rem;
        box-sizing: border-box;
        margin-bottom: 0.2rem;
     }
     .search_img{
        height: 0.28rem;
        width: 0.28rem;
     }
     .search_text{
        flex: 1;
        height: 0.6rem;
        line-height: 0.6rem;
        font-size: 0.3rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #666;
        padding-left: 0.2rem;
        box-sizing: border-box;
     }
     .search_cancel{
        font-size: 0.26rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #666666;
     }
     .unit_center_select{
         display: flex;
         flex-direction: row;
         height: 0.8rem;
         /* margin-bottom: 0.29rem; */
         margin-top: 0.2rem;
     }
     .unit_center_select_item{
        width: 1.80rem;
        height: 0.8rem;
        background: #FFFFFF;
        font-size: 0.28px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #282828;
        border-radius: 0.05rem;
        margin-right: 0.2rem;
     }
     .unit_center_select_itemText{
         width: 1.8rem;
        height: 0.8rem;
        background: #67C23A;
        font-size: 0.20px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #fff;
        border-radius: 0.05rem;
        /* margin-right: 0.2rem; */
     }
     .select_item_imgs{
         width: 0.21rem;
         height: 0.12rem;
         margin-left: 0.23rem;
     }
     .select_btns{
        width: 1.54rem;
        height: 0.8rem;
        background: #FFFFFF;
        border-radius: 0.05rem;
        text-align: center;
     }
     .unit_center_footer{
         background: #fff;
         padding-top: 2.6rem;
         box-sizing: border-box;
     }
     .footer_boxs{
         padding:0 0.2rem;
         padding-top: 0.27rem;
         padding-bottom: 0.34rem;
         box-sizing: border-box;
     }
     .footer_name{
        height: 0.6rem;
        text-align: center;
        line-height: 0.6rem;
        background: #E6A23C;
        font-size: 0.24rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
     }
     .footer_text{
        flex: 1;
        font-size: 0.24rem;
        text-align: center;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #282828;
        text-align: center;

     }
     .unit_center_list{
         padding: 0.2rem;
         box-sizing: border-box;
         border-bottom: 0.01rem solid #DDDDDD;
     }
     .footer_list{
         padding-bottom: 0.19rem;
         box-sizing: border-box;

     }
     .footer_list_bot{
         display: flex;
         justify-content: space-between;
     }
     .footer_nums{
         /* flex: 1; */
        font-size: 0.28rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
        width: 1.2rem;
        text-align: left;
     }
     .footer_item{
          flex: 1;
        font-size: 0.24rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
        /* width: 1.2rem; */
        text-align: center;
     }
     .pofig{
         position: fixed;
         left: 0;
         bottom: 0;
         height: 0.98rem;
         width: 100%;
     }
     .pofig_item{
        background: #FFFFFF;
        box-shadow: 0px 1px 5px 0px rgba(69, 69, 69, 0.2);
        font-size: 0.28rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #666666;
     }
     .pofig_item_imgs{
         width: 0.24rem;
         height: 0.26rem;
         margin-right: 0.1rem;
     }
</style>
